import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getAutomations = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/automations/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createAutomation = ({
  version = 'v1',
  params = {},
  payload,
} = {}) =>
  client
    .request({
      url: `${version}/automations/`,
      method: RequestMethod.POST,
      params,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAutomation = ({
  version = 'v1',
  params = {},
  payload,
  id,
} = {}) =>
  client
    .request({
      url: `${version}/automations/${id}/`,
      method: RequestMethod.PATCH,
      params,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAutomationClasses = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/automations/class-choices/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const triggerAutomation = ({ version = 'v1', params = {}, id } = {}) =>
  client
    .request({
      url: `${version}/automations/${id}/trigger-automation/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
